import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Alert,
  CircularProgress
} from '@mui/material';

const EditCategoryDialog = ({ open, onClose, category, onSave }) => {
  const [formData, setFormData] = useState({
    name_fin: '',
    name_fr: '',
    name_de: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (category) {
      setFormData({
        name_fin: category.name_fin || '',
        name_fr: category.name_fr || '',
        name_de: category.name_de || ''
      });
      setError('');
      setSuccess(false);
    }
  }, [category]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async () => {
    if (!formData.name_fin || !formData.name_fr || !formData.name_de) {
      setError('All fields are required');
      return;
    }

    setLoading(true);
    setError('');

    const payload = {
      id: parseInt(category.id),
      name_fin: formData.name_fin,
      name_fr: formData.name_fr,
      name_de: formData.name_de
    };

    console.log('Sending JSON payload:', JSON.stringify(payload));

    try {
      const response = await fetch('https://api.elnaf.fi/api/add_category_translation.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      console.log('Response status:', response.status);
      console.log('Response headers:', response.headers);

      const responseText = await response.text();
      console.log('Response text:', responseText);

      let data;
      try {
        data = JSON.parse(responseText);
      } catch (e) {
        console.error('Failed to parse JSON:', e);
        throw new Error('Invalid JSON response from server');
      }

      if (response.ok && data.status === 'success') {
        setSuccess(true);
        setTimeout(() => {
          onSave();
          onClose();
        }, 1500);
      } else {
        setError(data.message || 'Failed to update category');
      }
    } catch (err) {
      console.error('Error:', err);
      setError(err.message || 'Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (!category) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Edit Category Translations
        <Box component="span" sx={{ display: 'block', fontSize: '14px', color: 'text.secondary', mt: 1 }}>
          ID: {category.id} | English: {category.name_en}
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          
          {success && (
            <Alert severity="success" sx={{ mb: 2 }}>
              Category translations updated successfully!
            </Alert>
          )}
          
          <TextField
            fullWidth
            label="Finnish Name"
            name="name_fin"
            value={formData.name_fin}
            onChange={handleChange}
            margin="normal"
            required
          />
          
          <TextField
            fullWidth
            label="French Name"
            name="name_fr"
            value={formData.name_fr}
            onChange={handleChange}
            margin="normal"
            required
          />
          
          <TextField
            fullWidth
            label="German Name"
            name="name_de"
            value={formData.name_de}
            onChange={handleChange}
            margin="normal"
            required
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading || success}>
          Cancel
        </Button>
        <Button 
          onClick={handleSubmit} 
          variant="contained" 
          disabled={loading || success}
          startIcon={loading && <CircularProgress size={20} />}
        >
          {success ? 'Saved!' : 'Save Changes'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditCategoryDialog;